import React, { Fragment, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  getCollegeFees,
  getStudentProfileByFormNumber,
  getPayableFeeForStudent,
} from "../../api/admissionApi";
import moment from "moment";
import LoaderSpinner from "../../common/LoaderSpinner";
import Popup from "../../Shared/Popup";
import fail from "../../../assets/failed.gif";
import hooray from "../../../assets/enjoy.gif";

export default function ExaminationStatusCourseFeePayment(props = {}) {
  const {
    isEdit = false,
    isCreate = false,
    verifyAndSearchUser,
    verificationSuccess,
    searchingUser,
    userInformation = {},
    currentUser,
    setActiveTab,
    // existingDA,
    existingSalaryConfig = {},
    editorId = "",
    history,
    isUpdating,
    permissions = {},
    activeTab,
  } = props;
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    authenticationReducer: {
      studentProfile: { student_id, studentId_generate_date, class_roll_number, classRoll_generate_date, is_registration_completed, email_id, formNumber, examination_status :{is_examination_passed = "", update_date} = {}, entranceRollNumber, payment_status: { total_fee_paid = "", documents_verified, isPaymentVerified, doc_verification_date, payment_date, isCollegeFeePaid, collegeFeesPaidDate, roll_no_generate_date } = {} },
      isStudent,
    } = {},
    admissionReducer: { isUserProfileLoading = false } = {},
  } = state || {};

  const [isFetchingData, setIsFetchingData] = useState(true);
  const getPayableFee = (email, cbs) =>
    dispatch(getPayableFeeForStudent({ email_id: email }, cbs));
  const [payableFees, setPayableFees] = useState(0);
  const getStudProfileByFormNo = (formNumber, cbs) =>
    dispatch(getStudentProfileByFormNumber(formNumber, cbs));
  const [isCollegeFeesPaid, setIsCollegeFeesPaid] = useState(false);

  useEffect(() => {
    if(!total_fee_paid) getPayableFee(email_id, {
      successCallback: (response) => {
        setPayableFees(response.feeToBePaid);
      },
      failureCallback: (errData) => {
        setPayableFees(0);
        toast.error("Couldn't fetch the payable fees for this account.");
      },
    });

    getStudProfileByFormNo(formNumber, {
      successCallback: (response) => {
        const { status, profileDetails: { payment_status = {} } = {} } =
          response;
        if (status) {
          setIsCollegeFeesPaid(payment_status.isCollegeFeePaid);
          dispatch({ type: 'SET_STUDENT_PROFILE', payload: { profile: { ...response.profileDetails, isStudent: true, loginType: "student" } } });
        }
        else setIsCollegeFeesPaid(false);
        setIsFetchingData(false);
      },
      failureCallback: (errData) => {
        if (errData !== undefined && errData.data)
          toast.error(errData.data.err);
      },
    });
  }, []);

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">
                  Examination status cum fees information
                </h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href>St. Andrews College</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Examination status & payable fees
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderContent = () => {
    const isAdmissionConfirmed = Boolean(is_examination_passed && formNumber && isCollegeFeesPaid && total_fee_paid && entranceRollNumber && student_id && class_roll_number);
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">
            Below are your final status for entrance examination and details for
            your payable course fees:
          </h3>
        </div>
        <div className="pl-20">
          {isFetchingData ? (
            <LoaderSpinner />
          ) : (
            <Fragment>
              <p>Examination status (passed/failed) : {is_examination_passed === true ? "Passed" : is_examination_passed === false ? "Failed" : "Awaiting results..."} </p>
              <p>Form number : {formNumber}</p>
              <p>
                College entrance fees (paid/unpaid) :{" "}
                {isCollegeFeesPaid ? "Paid" : "UnPaid"}
              </p>
              <p>Entrance roll number : {entranceRollNumber}</p>
              {(is_examination_passed === true) && 
              <Fragment>
                {total_fee_paid ? (<div className="pb-10">Total course fees paid: Rs. {total_fee_paid}</div>) : (<p className="pb-10">
                  Payable course fees for this year : &#8377;
                  {payableFees ? payableFees : "NA"}
                </p>)}
                {payableFees!==0 && (
                  <p
                    className="pb-10"
                    style={{ fontWeight: "bold" }}
                  >
                    Kindly prepare a demand draft for given payable amount, or
                    visit college admission department for paying via other mode of payments and
                    payment verification.
                  </p>
                )}
              </Fragment>}
              { student_id && <p>Student ID : {student_id}</p>}
              { class_roll_number && <p>Class roll number : {class_roll_number}</p>}

             {isAdmissionConfirmed === true && <p className="font-weight-bold"><img src={hooray} alt="fail" width="4%"/>Congratulations on your successful admission to our college.</p>}
             {is_examination_passed === false && <p className="font-weight-bold"><img src={fail} alt="fail" width="2%"/>Sorry ! we couldn't proceed with your registration since you were unable to clear the examination.</p>}
            </Fragment>
          )}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid mb-15">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}
